export default {
  SCENE: 'Scene',
  MEDIA: 'Media',
  AUDIO: 'Audio',
  MAP_FLOOR_PLAN: 'MapFloorPlan',
};
